export function directorDashboardHomePath(schoolId?: number) {
  if (schoolId) return `/admin/${schoolId}/home`
  return '/admin/myschool/home'
}

export function directorDashboardWebsitePath(schoolId?: number) {
  if (schoolId) return `/admin/${schoolId}/website`
  return '/admin/myschool/website'
}
